// Nuvia Pets — utilidades JS compartidas por las secciones mt-*

(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    els.forEach(function (el) { observer.observe(el); });
  }

  function initContadores() {
    var els = document.querySelectorAll('.mt-contador');
    if (!els.length) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          observer.unobserve(el);
          var fin = parseFloat(el.dataset.mtFin || '0');
          var decimales = (el.dataset.mtFin || '').includes('.') ? 1 : 0;
          var sufijo = el.dataset.mtSufijo || '';

          if (reduced) {
            el.textContent = fin.toFixed(decimales) + sufijo;
            return;
          }

          var inicio = 0;
          var duracion = 1400;
          var t0 = null;

          function paso(ts) {
            if (!t0) t0 = ts;
            var progreso = Math.min((ts - t0) / duracion, 1);
            var facilitado = 1 - Math.pow(1 - progreso, 3);
            var valor = inicio + (fin - inicio) * facilitado;
            el.textContent = valor.toFixed(decimales) + sufijo;
            if (progreso < 1) requestAnimationFrame(paso);
          }
          requestAnimationFrame(paso);
        });
      },
      { threshold: 0.4 }
    );

    els.forEach(function (el) { observer.observe(el); });
  }

  function initMarquesinas() {
    var wraps = document.querySelectorAll('.mt-marquesina');
    wraps.forEach(function (wrap) {
      if (wrap.dataset.mtInit) return;
      wrap.dataset.mtInit = '1';
      var track = wrap.querySelector('.mt-marquesina-track');
      if (!track) return;
      // Duplica el contenido para el bucle infinito
      track.innerHTML += track.innerHTML;
    });
  }

  function initColorSelector() {
    var selectores = document.querySelectorAll('.mt-selector-color');
    selectores.forEach(function (selector) {
      var botones = selector.querySelectorAll('.mt-color-opcion');
      var imagen = selector.querySelector('.mt-color-imagen');
      botones.forEach(function (btn) {
        btn.addEventListener('click', function () {
          botones.forEach(function (b) { b.classList.remove('mt-color-activo'); });
          btn.classList.add('mt-color-activo');
          if (imagen && btn.dataset.mtImagen) {
            imagen.style.opacity = '0';
            setTimeout(function () {
              imagen.src = btn.dataset.mtImagen;
              imagen.style.opacity = '1';
            }, 200);
          }
        });
      });
    });
  }

  function cambiarFotoConFundido(img, nuevoSrc) {
    if (!img || !nuevoSrc || img.src === nuevoSrc) return;
    var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducido) { img.src = nuevoSrc; return; }
    img.classList.add('mt-galeria-cambiando');
    window.setTimeout(function () {
      img.src = nuevoSrc;
      var mostrar = function () { img.classList.remove('mt-galeria-cambiando'); };
      if (img.complete) mostrar();
      else img.addEventListener('load', mostrar, { once: true });
    }, 180);
  }

  function initGaleria() {
    document.querySelectorAll('.mt-galeria-mini').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var targetId = btn.dataset.mtGaleriaTarget;
        var img = document.getElementById(targetId);
        if (img && btn.dataset.mtGaleriaSrc) cambiarFotoConFundido(img, btn.dataset.mtGaleriaSrc);
        var hermanos = btn.parentElement.querySelectorAll('.mt-galeria-mini');
        hermanos.forEach(function (h) { h.classList.remove('mt-galeria-mini-activa'); });
        btn.classList.add('mt-galeria-mini-activa');
      });
    });
  }

  function initCantidad() {
    document.querySelectorAll('.mt-cantidad').forEach(function (wrap) {
      var input = wrap.querySelector('[data-mt-cantidad-input]');
      var menos = wrap.querySelector('[data-mt-cantidad-menos]');
      var mas = wrap.querySelector('[data-mt-cantidad-mas]');
      if (!input) return;
      menos && menos.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.value = v;
      });
      mas && mas.addEventListener('click', function () {
        var v = (parseInt(input.value, 10) || 1) + 1;
        input.value = v;
      });
    });
  }

  function formatoDinero(montoEnCentimos, formato) {
    var monto = montoEnCentimos / 100;
    var amount = (Math.round(monto * 100) / 100).toFixed(2);
    var amountNoDecimales = String(Math.round(monto));
    var amountConComa = amount.replace('.', ',');
    if (!formato) return '€' + amount;
    return formato
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, amountNoDecimales)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amountConComa)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, amountNoDecimales);
  }

  function initProductoVariantes() {
    document.querySelectorAll('.mt-producto-compra').forEach(function (cont) {
      var script = cont.querySelector('[data-mt-variantes]');
      if (!script) return;
      var variantes;
      try {
        variantes = JSON.parse(script.textContent);
      } catch (e) {
        return;
      }
      var formatoPrecio = cont.dataset.mtMoneyFormat;
      var input = cont.querySelector('[data-mt-variant-input]');
      var precioEl = cont.querySelector('[data-mt-precio]');
      var comparadoEl = cont.querySelector('[data-mt-precio-comparado]');
      var ahorroEl = cont.querySelector('[data-mt-precio-ahorro]');
      var botonComprar = cont.querySelector('[data-mt-boton-comprar]');
      var botonTexto = cont.querySelector('[data-mt-boton-texto]');

      function seleccionActual() {
        var seleccion = {};
        cont.querySelectorAll('.mt-opcion').forEach(function (grupo) {
          var activo = grupo.querySelector('.mt-opcion-valor-activa');
          var indice = activo ? activo.dataset.mtOpcionIndex : null;
          if (indice) seleccion[indice] = activo.dataset.mtOpcionValor;
        });
        return seleccion;
      }

      function encontrarVariante(seleccion) {
        return variantes.find(function (v) {
          return (!seleccion[1] || v.option1 === seleccion[1]) &&
                 (!seleccion[2] || v.option2 === seleccion[2]) &&
                 (!seleccion[3] || v.option3 === seleccion[3]);
        });
      }

      var grid = cont.closest('.mt-producto-grid');
      var galeriaImg = grid ? grid.querySelector('.mt-galeria-principal img') : null;
      var miniaturas = grid ? grid.querySelectorAll('.mt-galeria-mini') : [];

      function actualizarImagenVariante(variante) {
        if (!galeriaImg) return;
        var src = variante.featured_image && (variante.featured_image.src || variante.featured_image);
        if (!src) return;
        cambiarFotoConFundido(galeriaImg, src);
        miniaturas.forEach(function (mini) {
          var esLaMisma = (mini.dataset.mtGaleriaSrc || '').split('?')[0] === String(src).split('?')[0];
          mini.classList.toggle('mt-galeria-mini-activa', esLaMisma);
        });
      }

      function actualizar() {
        var variante = encontrarVariante(seleccionActual());
        if (!variante) return;
        input.value = variante.id;
        actualizarImagenVariante(variante);
        if (precioEl) precioEl.textContent = formatoDinero(variante.price, formatoPrecio);
        var tieneDescuento = variante.compare_at_price && parseFloat(variante.compare_at_price) > parseFloat(variante.price);
        if (comparadoEl) {
          if (tieneDescuento) {
            comparadoEl.textContent = formatoDinero(variante.compare_at_price, formatoPrecio);
            comparadoEl.style.display = '';
          } else {
            comparadoEl.style.display = 'none';
          }
        }
        if (ahorroEl) {
          if (tieneDescuento) {
            var pct = Math.round((variante.compare_at_price - variante.price) / variante.compare_at_price * 100);
            ahorroEl.textContent = '-' + pct + '%';
            ahorroEl.style.display = '';
          } else {
            ahorroEl.style.display = 'none';
          }
        }
        if (botonComprar) {
          botonComprar.disabled = !variante.available;
          if (botonTexto) {
            botonTexto.textContent = variante.available
              ? botonComprar.dataset.mtTextoComprar
              : botonComprar.dataset.mtTextoAgotado;
          }
        }
        var precioFijaEl = document.querySelector('[data-mt-precio-fija]');
        if (precioFijaEl) precioFijaEl.textContent = formatoDinero(variante.price, formatoPrecio);
        var botonFija = document.querySelector('[data-mt-boton-comprar-fija]');
        if (botonFija) {
          botonFija.disabled = !variante.available;
          var botonFijaTexto = botonFija.querySelector('[data-mt-boton-texto-fija]');
          if (botonFijaTexto) {
            botonFijaTexto.textContent = variante.available
              ? botonFija.dataset.mtTextoComprar
              : botonFija.dataset.mtTextoAgotado;
          }
        }
      }

      cont.querySelectorAll('.mt-opcion-valor').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var grupo = btn.closest('.mt-opcion');
          grupo.querySelectorAll('.mt-opcion-valor').forEach(function (b) { b.classList.remove('mt-opcion-valor-activa'); });
          btn.classList.add('mt-opcion-valor-activa');
          actualizar();
        });
      });
    });
  }

  function initCompraFija() {
    var fija = document.querySelector('[data-mt-compra-fija]');
    var objetivo = document.querySelector('.mt-producto-cta-row');
    if (!fija || !objetivo) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var pasadoPorArriba = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          fija.classList.toggle('mt-compra-fija-visible', pasadoPorArriba);
        });
      },
      { threshold: 0 }
    );
    observer.observe(objetivo);

    var botonFija = fija.querySelector('[data-mt-boton-comprar-fija]');
    var botonReal = document.querySelector('[data-mt-boton-comprar]');
    if (botonFija && botonReal) {
      botonFija.addEventListener('click', function () { botonReal.click(); });
    }
  }

  function initTarjetasInclinadas() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(hover: none)').matches) return;
    var tarjetas = document.querySelectorAll('.mt-color-card, .mt-beneficio');
    tarjetas.forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.classList.add('mt-card-inclinada');
        card.style.transform = 'perspective(800px) rotateY(' + (x * 7).toFixed(2) + 'deg) rotateX(' + (y * -7).toFixed(2) + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function () {
        card.classList.remove('mt-card-inclinada');
        card.style.transform = '';
      });
    });
  }

  function initBotonCompraFeedback() {
    var form = document.getElementById('mt-form-producto');
    if (!form) return;
    form.addEventListener('submit', function () {
      var botones = [
        form.querySelector('[data-mt-boton-comprar]'),
        document.querySelector('[data-mt-boton-comprar-fija]')
      ];
      botones.forEach(function (boton) {
        if (boton && !boton.disabled) {
          boton.classList.add('mt-boton-cargando');
          window.setTimeout(function () { boton.classList.remove('mt-boton-cargando'); }, 1500);
        }
      });
    });
  }

  function initVolverArriba() {
    var boton = document.querySelector('[data-mt-volver-arriba]');
    if (!boton) return;
    window.addEventListener('scroll', function () {
      boton.classList.toggle('mt-volver-arriba-visible', window.scrollY > 500);
    }, { passive: true });
    boton.addEventListener('click', function () {
      var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reducido ? 'auto' : 'smooth' });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initContadores();
    initMarquesinas();
    initColorSelector();
    initGaleria();
    initCantidad();
    initProductoVariantes();
    initCompraFija();
    initVolverArriba();
    initTarjetasInclinadas();
    initBotonCompraFeedback();
  });
})();
